// extracted by mini-css-extract-plugin
export default {"tippy-tooltip":"Tooltip_tippy-tooltip__PQLQf"};